import { lazy, Suspense } from 'react';
import SEOHead from '../../components/SEOHead';

const Hero = lazy(() => import('./components/Hero'));
const ValueProposition = lazy(() => import('./components/ValueProposition'));
const AboutTrust = lazy(() => import('./components/AboutTrust'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const Contact = lazy(() => import('./components/Contact'));
const TechnicalInfo = lazy(() => import('./components/TechnicalInfo'));

function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kustura-sportscar-insurance.de';

  const schema = {
    "@context": "https://schema.org",
    "@type": "InsuranceAgency",
    "name": "Kustura Sportscar Insurance",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "description": "Kustura Sportscar Insurance – maßgeschneiderte Versicherungslösungen für Sport- und Luxusfahrzeuge. Persönlich, zuverlässig und leistungsstark. In Deutschland, Essen.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Im Teelbruch 84",
      "addressLocality": "Essen",
      "postalCode": "45219",
      "addressRegion": "NW",
      "addressCountry": "DE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "51.4556",
      "longitude": "7.0116"
    },
    "telephone": "+49-162-2122662",
    "email": "team@kustura-sportscar-insurance.de",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "17:00"
    },
    "priceRange": "$$",
    "areaServed": {
      "@type": "City",
      "name": "Essen"
    },
    "sameAs": []
  };

  return (
    <>
      <SEOHead
        title="Kustura Sportscar Insurance"
        description="Kustura Sportscar Insurance – maßgeschneiderte Versicherungslösungen für Sport- und Luxusfahrzeuge. Persönlich, zuverlässig und leistungsstark. In Deutschland, Essen."
        keywords="Kustura, Sportscar, Insurance, Versicherung, Sportwagen, Auto, Kfz, Rennstrecke, Rennstreckenversicherung, Auto Versicherung"
        canonical={`${siteUrl}/`}
        schema={schema}
      />
      <div className="min-h-screen bg-black">
        <Suspense fallback={<div className="min-h-screen bg-black"></div>}>
          <Hero />
          <ValueProposition />
          <AboutTrust />
          <Testimonials />
          <Contact />
          <TechnicalInfo />
        </Suspense>
      </div>
    </>
  );
}

export default HomePage;